import { hoursHeapAttributes } from './hours/hoursHeapAttributes'
import { linkedLocationProfilesHeapAttributes } from './linkedLocationProfiles/linkedLocationProfilesHeapAttributes'

export const LOCATION_DETAILS_PREFIX = 'location-details'

export const LocationDetailPanelsHeapAttributes = {
  coreInfoPanel: `${LOCATION_DETAILS_PREFIX}-core-info-panel`,
  hoursPanel: `${LOCATION_DETAILS_PREFIX}-hours-panel`,
  menusPanel: `${LOCATION_DETAILS_PREFIX}-menus-panel`,
  businessPanel: `${LOCATION_DETAILS_PREFIX}-business-panel`,
  websitesPanel: `${LOCATION_DETAILS_PREFIX}-websites-panel`,
  photoPanel: `${LOCATION_DETAILS_PREFIX}-photo-panel`,
  linkedPanel: `${LOCATION_DETAILS_PREFIX}-linked-panel`,
} as const

export const LocationDetailsHeapAttributes = {
  ...LocationDetailPanelsHeapAttributes,
  ...hoursHeapAttributes,
  ...linkedLocationProfilesHeapAttributes,
} as const
